import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { TextField, Button, Box, Typography, InputLabel, Select, MenuItem, FormControl, Grid, Dialog, DialogTitle, DialogContent, DialogActions, FormControlLabel, Checkbox } from '@mui/material';
import { addKind, getTypes } from '../../api/axios';
import Kinds from '../List/Kinds';

const NewKind = () => {
    const { t } = useTranslation("global");
    const [types, setTypes] = useState([]);
    const daysOfWeek = [
        { id: 1, name: t("days.monday") },
        { id: 2, name: t("days.tuesday") },
        { id: 3, name: t("days.wednesday") },
        { id: 4, name: t("days.thursday") },
        { id: 5, name: t("days.friday") },
        { id: 6, name: t("days.saturday") },
        { id: 7, name: t("days.sunday") }
    ];

    const [formData, setFormData] = useState({
        kind_name: '',
        day_no: '0',
        entry_no: '0',
        daily_no: '0',
        time_from: '00:00:00',
        time_to: '23:59:59',
        type_id: '',
    });

    const [selectedDays, setSelectedDays] = useState([1,2,3,4,5,6,7]); // Default all days selected
    const [isDaysModalOpen, setIsDaysModalOpen] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    useEffect(() => {
        fetchInitialData();
    }, []);

    const fetchInitialData = async () => {
        const typesData = await getTypes();
        setTypes(typesData);
        console.log(types);
    };
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const handleTypeChange = (e) => {
        const selectedTypeId = e.target.value;
        setFormData({ ...formData, type_id: selectedTypeId });
    };

    const handleDayChange = (e) => {
        const value = parseInt(e.target.value);
        setSelectedDays(prev => 
            prev.includes(value) 
                ? prev.filter(d => d !== value) 
                : [...prev, value]
        );
    };

    const handleSubmit = async () => {
        const { kind_name, day_no, entry_no, daily_no, time_from, time_to, type_id } = formData;

        if (!kind_name || !day_no || !entry_no || !daily_no || !time_from || !time_to || !type_id) {
            setErrorMessage(t('priceList.PleaseFillInAllRequiredFields'));
            return;
        }

        if (isNaN(day_no) || isNaN(entry_no) || isNaN(daily_no) || day_no < 0 || entry_no < 0 || daily_no < 0) {
            setErrorMessage(t('priceList.DayEntryDailyNonNegativeIntegers'));
            return;
        }

        try {
            const params = new URLSearchParams();
            params.append('kind_name', kind_name);
            params.append('day_no', day_no);
            params.append('entry_no', entry_no);
            params.append('daily_no', daily_no);
            params.append('time_from', time_from);
            params.append('time_to', time_to);
            params.append('type', type_id);
            params.append('templates', 'NULL');
            params.append('allowed_days', selectedDays.join(','));

            await addKind(params);
            setSuccessMessage(t('priceList.KindAddedSuccessfully'));
            setErrorMessage('');
            setFormData({
                kind_name: '',
                day_no: '0',
                entry_no: '0',
                daily_no: '0',
                time_from: '00:00:00',
                time_to: '23:59:59',
                type_id: '',
            });
            setSelectedDays([1,2,3,4,5,6,7]); // Reset to all days
            // Trigger refresh of Kinds table
            window.dispatchEvent(new Event('refreshKinds'));
        } catch (error) {
            setErrorMessage(t('priceList.FailedToAddKind'));
            setSuccessMessage('');
        }
    };

    return (
        <Grid container spacing={2} sx={{
                width: '100%',
                maxWidth: '80%',
                margin: '0 auto',
                mt: 4,
                backgroundColor: 'white',
                p: 5,
                borderRadius: 3,
            }}>
            <Grid item xs={12}>
                <Typography variant="h5" textAlign="center">
                    {t('priceList.AddNewKind')}
                </Typography>
            </Grid>

            <Grid item xs={6}>
                <TextField
                    label={t('priceList.KindName')}
                    name="kind_name"
                    value={formData.kind_name}
                    onChange={handleChange}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('priceList.DayNo')}
                    name="day_no"
                    value={formData.day_no}
                    onChange={handleChange}
                    fullWidth
                    type="number"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('priceList.EntryNo')}
                    name="entry_no"
                    value={formData.entry_no}
                    onChange={handleChange}
                    fullWidth
                    type="number"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('priceList.DailyNo')}
                    name="daily_no"
                    value={formData.daily_no}
                    onChange={handleChange}
                    fullWidth
                    type="number"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('priceList.TimeFrom')}
                    name="time_from"
                    value={formData.time_from}
                    onChange={handleChange}
                    fullWidth
                    type="time"
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    label={t('priceList.TimeTo')}
                    name="time_to"
                    value={formData.time_to}
                    onChange={handleChange}
                    fullWidth
                    type="time"
                />
            </Grid>
            <Grid item xs={6}>
            <FormControl fullWidth required>
            <InputLabel>{t("priceList.type")}</InputLabel>
            <Select
                name="type_id"
                value={formData.type_id}
                onChange={handleTypeChange}>
                {types.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                    {type.name}
                </MenuItem>
                ))}
            </Select>
            </FormControl>
            </Grid>
            <Grid item xs={6}>
                <Button variant="outlined" onClick={() => setIsDaysModalOpen(true)} fullWidth>
                    {t("priceList.selectDays")}
                </Button>
            </Grid>
            <Grid item xs={6}>
                <Button variant="contained" color="primary" onClick={handleSubmit} sx={{width: "100%"}}>
                    {t('priceList.Submit')}
                </Button>
            </Grid>

            {/* Days Selection Modal */}
            <Dialog open={isDaysModalOpen} onClose={() => setIsDaysModalOpen(false)} fullWidth maxWidth="sm">
                <DialogTitle>{t("priceList.selectDays")}</DialogTitle>
                <DialogContent>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={selectedDays.length === 7}
                                onChange={(e) => {
                                    setSelectedDays(e.target.checked ? [1,2,3,4,5,6,7] : []);
                                }}
                            />
                        }
                        label={t("priceList.all")}
                    />
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Grid container spacing={1}>
                                {daysOfWeek.slice(0, 5).map((day) => (
                                    <Grid item xs={12} key={day.id}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                checked={selectedDays.includes(day.id)}
                                                    onChange={handleDayChange}
                                                    value={day.id}
                                                />
                                            }
                                            label={day.name}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={1}>
                                {daysOfWeek.slice(5).map((day) => (
                                    <Grid item xs={12} key={day.id}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedDays.includes(day.id)}
                                                    onChange={handleDayChange}
                                                    value={day.id}
                                                />
                                            }
                                            label={day.name}
                                        />
                                    </Grid>
                                ))}
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsDaysModalOpen(false)} variant="contained" color="primary">
                        {t("priceList.ok")}
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid item xs={12}>
                <Kinds/>
            </Grid>
            <Grid item xs={12}>
                {errorMessage && (
                    <Typography variant="body2" color="error" textAlign="center">
                        {errorMessage}
                    </Typography>
                )}
                {successMessage && (
                    <Typography variant="body2" color="success.main" textAlign="center">
                        {successMessage}
                    </Typography>
                )}
            </Grid>
        </Grid>
    );
};

export default NewKind;
